import { NUMBER_OF_SWATCHES_TO_SHOW } from 'commons/constants';

export const getHighlightedOptionColors = (product, items) => {
  // find the item object from Algolia that corresponds to this product
  const algoliaItem = items.find(
    item => String(item.product_id) === String(product.id)
  );

  if (algoliaItem?._highlightResult?.option_color === undefined) {
    return [];
  }

  // creates array of highlighted option colors like ["red", "blue"]
  const matchedColors = [
    ...new Set(
      algoliaItem?._highlightResult?.option_color
        ?.filter(color => color.matchLevel !== 'none')
        ?.map(highlight => highlight.value.replace(/<\/?mark>/g, '')) // remove <mark> tags
        ?.flat()
        ?.map(word => word.toLowerCase())
    ),
  ];

  return matchedColors || [];
};

export const getVariantsByMatchedColorFirst = (product, items) => {
  const matchedColors = getHighlightedOptionColors(product, items);

  if (matchedColors.length === 0) {
    return product?.variantsToShow?.length === 0
      ? product?.variants.slice(0, NUMBER_OF_SWATCHES_TO_SHOW)
      : product?.variantsToShow || [];
  }

  const matchedVariants = [
    ...new Map(
      matchedColors.map(color =>
        product.variants.filter(
          variant => variant.color && variant.color === color
        )
      )
    )
      .values()
      .filter(Boolean),
  ];

  const variantsToShow = [
    ...new Map(
      [
        ...(matchedVariants ?? []),
        ...(product?.variantsToShow ?? []),
      ].map(item => [item?.sku, item])
    ).values(),
  ];

  return variantsToShow.length > 0
    ? variantsToShow.slice(0, NUMBER_OF_SWATCHES_TO_SHOW)
    : product?.variantsToShow;
};
